export const MY_PEOPLE_EVALS_FETCH_LIMIT = 50;
export const DEFAULT_PAGINATION_DATA = {
  limit: MY_PEOPLE_EVALS_FETCH_LIMIT,
  offset: 0,
};
